module.exports = __webpack_public_path__ + "static/media/getreadyforexam.2815f735.svg";